import { render } from "./ArticleCardSkeleton.vue?vue&type=template&id=66a068e4&scoped=true"
const script = {}

import "./ArticleCardSkeleton.vue?vue&type=style&index=0&id=66a068e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a068e4"]])

export default __exports__